import React from 'react';
import '../../../resources/css/loja.css';
import LojaVendas from "./LojaVendas.jsx";
import LojaCaixa from "./LojaCaixa.jsx";
import LojaExpedicao from "./LojaExpedicao.jsx";

import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';

class Loja extends React.Component {

    render() {
        const app = this.props.app;
        if (app.landPage !== LandPageTypes.ADMIN)
            return null;

        const selectPage = (type) => {
            switch (type) {
                case AdminPageTypes.VENDA:
                    return <LojaVendas {...this.props} />;

                case AdminPageTypes.CAIXA:
                    return <LojaCaixa {...this.props} />;

                case AdminPageTypes.EXPEDICAO:
                    return <LojaExpedicao {...this.props} />;

                default:
                    return null;
            }
        };

        return selectPage(app.adminPage) || selectPage(this.props.loja.currentPage);
    }
}

export default Loja;



// WEBPACK FOOTER //
// src/views/pages/Loja.jsx